export default __webpack_public_path__ + "pgnv-assets/1bd1638705a0eeff105da8912d136216.png";